import React from 'react';
import { FieldArray } from 'redux-form';
import { FormDataConsumer } from 'react-admin';

import isBlank from '../../../Common/Utils/Blank';
import isPresent from '../../../Common/Utils/Present';
import MonitorChecks from './MonitorChecks';

type Props = {
  record: any
};

const MonitorsTab = (props: Props) => (
  <div>
    <FormDataConsumer>
      {({ formData, ...rest }) => formData && isBlank(formData.source) &&
        <div style={{ padding: 20 }}>
          You must select a source before defining a monitoring check.
        </div>
      }
    </FormDataConsumer>

    <FormDataConsumer>
      {({ formData, ...rest }) => formData && formData.source === 'MongoDB' &&
        <div style={{ padding: 20 }}>
          Monitor checks apply to RedShift DB sources.
        </div>
      }
    </FormDataConsumer>

    <FormDataConsumer>
      {({ formData, ...rest }) => formData && isPresent(formData.source) && formData.source !== 'MongoDB' &&
        <div style={{ paddingTop: 20 }}>
          <FieldArray
            component={MonitorChecks}
            name='checks'
            record={props.record} />
        </div>
      }
    </FormDataConsumer>
  </div>
);

export default MonitorsTab;



// WEBPACK FOOTER //
// ./src/views/Components/Monitors/Partials/MonitorsTab.tsx